<div class="body-card pt-3">
  <p-table
    [value]="processes"
    class="custom-table"
    [loading]="loading"
    [paginator]="true"
    [rowsPerPageOptions]="[5, 10, 20]"
    [rows]="5"
  >
    <ng-template pTemplate="header">
      <tr>
        <th>
          <div class="flex justify-content-center">
            {{ "UserPalletStock.PalletStockImport.NameColumn" | translate }}
          </div>
        </th>
        <th>
          <div class="flex justify-content-center">
            {{ "UserPalletStock.PalletStockImport.TypeColumn" | translate }}
          </div>
        </th>
        <th>
          <div class="flex justify-content-center">
            {{ "UserPalletStock.PalletStockImport.StatusColumn" | translate }}
          </div>
        </th>
        <th>
          <div class="flex justify-content-center">
            {{ "UserPalletStock.PalletStockImport.CreatedColumn" | translate }}
          </div>
        </th>
        <th>
          <div class="flex justify-content-center">
            {{ "UserPalletStock.PalletStockImport.MessageColumn" | translate }}
          </div>
        </th>
        <th>
          <div class="flex justify-content-center">
            {{ "UserPalletStock.PalletStockImport.ActionsColumn" | translate }}
          </div>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-process>
      <tr>
        <td>
          <div class="flex justify-content-center">
            {{ process.stockName }}
          </div>
        </td>
        <td>
          <div class="flex justify-content-center">
            {{
            process.stockId == null
              ? ('UserPalletStock.PalletStockImport.TypeCreation' | translate)
              : ('UserPalletStock.PalletStockImport.TypeUpdate' | translate)
            }}
          </div>
        </td>
        <td>
          <div class="flex justify-content-center">
            {{ getImportStatusLabel(process.status) }}
          </div>
        </td>
        <td>
          <div class="flex justify-content-center">
            {{ process.created | date:'dd-MM-yyyy HH:mm:ss' }}
          </div>
        </td>
        <td>
          <div class="flex justify-content-center">
            {{ process.errorMessage ?? "" }}
          </div>
        </td>
        <td>
        <div class="flex justify-content-center">
          <button
            *ngIf="process.status == PalletStockImportProcessStatus.Failed"
            pButton
            type="button"
            icon="pi pi-download"
            class="p-button-rounded p-button-text"
            pTooltip="{{'UserPalletStock.PalletStockImport.DownloadErrorsButton' | translate}}"
            (click)="downloadImportErrors(process)">
          </button>
        </div>
      </td>
      </tr>
    </ng-template>
  </p-table>
</div>
